var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8078 4.54297H4.96775C4.56462 4.54297 4.17801 4.70311 3.89295 4.98817C3.6079 5.27322 3.44775 5.65984 3.44775 6.06297V11.763",
    stroke: "currentColor",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96777 6.69629H8.38777",
    stroke: "currentColor",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96777 8.46973H8.38777",
    stroke: "currentColor",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96777 10.2432H6.67017",
    stroke: "currentColor",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6677 11.383V5.68297C10.6677 5.38062 10.7878 5.09066 11.0016 4.87687C11.2154 4.66308 11.5054 4.54297 11.8077 4.54297C12.1101 4.54297 12.4 4.66308 12.6138 4.87687C12.8276 5.09066 12.9477 5.38062 12.9477 5.68297V6.44297H10.6677",
    stroke: "currentColor",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10927_42511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.5V14.5C15.5 15.0333 15.0333 15.5 14.5 15.5H12.5",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H14.5C15.0333 0.5 15.5 0.966668 15.5 1.5V3.5",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5V1.5C0.5 0.966668 0.966667 0.5 1.5 0.5H3.5",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5H1.5C0.966667 15.5 0.5 15.0333 0.5 14.5V12.5",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10927_42511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.0f7483ac.svg";
export { ForwardRef as ReactComponent };